import React from 'react';
export default (props: { slideIconColor: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 20">
    <path
      fill={props.slideIconColor}
      d="M21.7 10.2l-11.6 9c-.2.2-.5.1-.7-.1-.1-.1-.1-.2-.1-.3v-4.5c0-.3-.2-.5-.5-.5H.7c-.3 0-.5-.2-.5-.5V6.4c0-.3.2-.5.5-.5h8.1c.3 0 .5-.2.5-.5V.8c0-.3.2-.5.5-.5.1 0 .2 0 .3.1l11.6 9c.2.2.2.5 0 .8.1-.1 0 0 0 0z"
    />
  </svg>
);
